module.exports = __webpack_public_path__ + "media/question3_en.1c30c3c9.wav";